(() => {
  const init = () => document.querySelectorAll('[data-qha-nano-compare]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const scroller = root.querySelector('.qha-scroll');
    const buttons = root.querySelectorAll('button[data-dir]');
    if (!scroller || buttons.length !== 2) return;
    const update = () => {
      buttons[0].disabled = scroller.scrollLeft < 2;
      buttons[1].disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
    };
    buttons.forEach(button => button.addEventListener('click', () => scroller.scrollBy({left:Number(button.dataset.dir) * 480,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'})));
    scroller.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(scroller);
    update();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
